import React from 'react';
import { useNavigate } from 'react-router-dom';

const OrderButton = () => {
  const navigate = useNavigate();

  const handleOrderClick = () => {
    navigate('/cart-summary');
  };

  return (
    // <button className="order-button" onClick={handleOrderClick}>Commander</button>
    <div className='alert alert-info'>Pour passer commande , ouvrir le panneau de droite</div>
  );
};

export default OrderButton;
